import styled, { css } from 'styled-components';

export const CenteredContentWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: ${(p) => p.justifyContent || 'space-between'};
  align-items: center;
`;

export const FlexWrapper = styled.div`
  display: flex;
  width: ${(p) => p.width ?? '100%'};
  justify-content: ${(p) => p.justifyContent ?? 'space-between'};
  flex-direction: ${(p) => p.flexDirection ?? 'row'};
  align-items: ${(p) => p.alignItems ?? 'center'};

  ${(p) =>
    p.flex &&
    css`
      flex: ${p.flex};
    `}
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${(p) => p.theme.colors.secondary90w};
  margin: 25px 0px;
`;
